import { Form, Input, InputNumber, Modal, Select, Table, Tag } from "antd";
import { get } from "lodash";
import { useState } from "react";
import { BiPlus } from "react-icons/bi";
import Header from "shared/components/Header";
import { useMutation, useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import cuid from "cuid";
import SenderDetail from "../Detail";

const STATUS_MAP = {
  active: { label: "Actif", color: "green" },
  paused: { label: "En pause", color: "orange" },
  disconnected: { label: "Déconnecté", color: "red" },
  limit_reached: { label: "Limite atteinte", color: "orange" },
};

const List = () => {
  const { data, refetch } = useQuery(graphql.queries.CRM_SENDERS, { variables: {}, fetchPolicy: "network-only" });
  const [createSender] = useMutation(graphql.mutations.CREATE_CRM_SENDER);
  const [createOpen, setCreateOpen] = useState(false);
  const [selectedSender, setSelectedSender] = useState(null);
  const [form] = Form.useForm();
  const senders = get(data, "crmSenders.data") || [];

  const handleCreate = async () => {
    const values = await form.validateFields();
    await createSender({
      variables: {
        data: {
          id: cuid(),
          email: values.email,
          displayName: values.displayName,
          provider: values.provider || "google",
          status: "active",
          dailyLimit: values.dailyLimit || 50,
          sentToday: 0,
          bounceRate: 0,
          assignedCampaignIds: [],
        },
      },
    });
    form.resetFields();
    setCreateOpen(false);
    await refetch();
  };

  return (
    <>
      <Header key="header" title="Expéditeurs" actions={[{ text: "Nouvel expéditeur", onClick: () => setCreateOpen(true), type: "primary", icon: <BiPlus size={18} /> }]} />
      <Table dataSource={senders} rowKey="id" size="small"
        onRow={(record) => ({
          onClick: () => setSelectedSender(record),
          style: { cursor: "pointer" },
        })}
        columns={[
        { title: "Email", dataIndex: "email", render: (email) => <strong>{email}</strong> },
        { title: "Nom", dataIndex: "displayName", width: 150 },
        { title: "Fournisseur", dataIndex: "provider", width: 100, render: (p) => <Tag>{p}</Tag> },
        { title: "Statut", dataIndex: "status", width: 120, render: (s) => { const m = STATUS_MAP[s] || { label: s, color: "default" }; return <Tag color={m.color}>{m.label}</Tag>; } },
        { title: "Limite", dataIndex: "dailyLimit", width: 80 },
        { title: "Envoyés", dataIndex: "sentToday", width: 80 },
        { title: "Rebond", dataIndex: "bounceRate", width: 80, render: (rate) => <span style={{ color: rate > 5 ? "#eb5757" : rate > 3 ? "#f2994a" : "#27ae60" }}>{rate || 0}%</span> },
        { title: "Campagnes", dataIndex: "assignedCampaignIds", width: 80, render: (ids) => (ids || []).length },
      ]} />

      <Modal title="Nouvel expéditeur" open={createOpen} onCancel={() => setCreateOpen(false)} onOk={handleCreate} okText="Créer" cancelText="Annuler">
        <Form form={form} layout="vertical">
          <Form.Item name="email" label="Email" rules={[{ required: true, message: "L'email est requis" }]}>
            <Input placeholder="alex@kayros.io" />
          </Form.Item>
          <Form.Item name="displayName" label="Nom affiché">
            <Input placeholder="Alex Martin" />
          </Form.Item>
          <Form.Item name="provider" label="Fournisseur" initialValue="google">
            <Select>
              <Select.Option value="google">Google</Select.Option>
              <Select.Option value="outlook">Outlook</Select.Option>
              <Select.Option value="smtp">SMTP</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item name="dailyLimit" label="Limite quotidienne" initialValue={50}>
            <InputNumber min={1} style={{ width: "100%" }} />
          </Form.Item>
        </Form>
      </Modal>

      <SenderDetail
        sender={selectedSender}
        open={!!selectedSender}
        onClose={() => setSelectedSender(null)}
        onRefetch={refetch}
      />
    </>
  );
};

export default List;
